import React from 'react';
import type { IWutBadgeProps } from '../WutBadge.props';
import { classes, st } from './style/WutBadge.component.st.css';

import CommonBadge from './WutBadgeCommon';

const Badge: React.FC<IWutBadgeProps> = props => {
  const { stylableClassName } = props as any;

  const classNames = {
    icon: classes.icon,
    root: st(classes.root, stylableClassName),
    outerWrapper: classes.outerWrapper,
    text: classes.text,
  };
  return <CommonBadge {...props} classNames={classNames} />;
};

export default Badge;
